import { FormTextField, FormTextFieldProps } from '@razz-team/ui-web';
import { validateBic } from '@razz-team/utils';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiAccountAddressFormat } from '../../openapi';

interface RoutingNumberFieldProps extends FormTextFieldProps {
  format: ApiAccountAddressFormat | null | undefined;
  secondary?: boolean;
}

export function RoutingNumberField({ format, secondary, ...props }: RoutingNumberFieldProps) {
  const { t } = useTranslation();

  const label = useMemo(() => {
    if (props.label) return props.label;

    if (__NODA__ && secondary) {
      return t('CNAPS / Routing number');
    }

    switch (format?.type) {
      case 'ABA':
        return t('ABA code');
      case 'BSB':
        return t('BSB code');
      case 'CNAPS':
        return t('CNAPS code');
      case 'ZENGIN':
        return t('Zengin code');
      case 'BANK_CODE':
        return t('Bank code');
      case 'SORT_CODE':
        return t('Sort code');
      default:
        return t('BIC / SWIFT code');
    }
  }, [format?.type, secondary, props.label, t]);

  const validate = useCallback(
    (value: string) => {
      switch (format?.type) {
        case 'BIC':
          return validateBic(value) ? true : t('Invalid {{label}}', { label });
        default:
          return true;
      }
    },
    [format?.type, label, t],
  );

  return (
    <FormTextField
      autoComplete="off"
      {...props}
      label={label}
      validate={validate}
      placeholder={format?.mask}
    />
  );
}
